<template>
  <el-form-item :label="i18nt('designer.setting.filter')">
    <el-switch v-model="optionModel.filter"></el-switch>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n";

  export default {
    name: "show-filter-editor",
    mixins: [i18n],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// show-filter-editor.vue?5b81e61f